import { noop } from 'rxjs';
import { MemoryService } from '../base/memoryService';
import { NULL_SERVICE, Service } from '../base/service';

export interface MarkdownService extends Service {
  readonly markdown: string;

  setMarkdown(markdown: string): void;
}

export const NULL_MARKDOWN_SERVICE: MarkdownService = {
  ...NULL_SERVICE,
  markdown: '',
  setMarkdown: noop,
};

export function createMemoryMarkdownService(markdown = ''): MarkdownService {
  return new MemoryMarkdownService(markdown);
}

export class MemoryMarkdownService extends MemoryService<string> implements MarkdownService {
  get markdown() {
    return this.state;
  }

  setMarkdown(markdown: string) {
    this.setState(markdown);
  }
}
